/* Ultimate FAQ Accordion — sections/faq-accordion.liquid */
(function () {
  if (customElements.get('faq-accordion')) return;

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.allowMultiple = this.dataset.allowMultiple === 'true';
      this.animationDuration = parseInt(this.dataset.animationDuration, 10) || 300;

      this.items = Array.from(this.querySelectorAll('[data-faq-item]'))
        .map((item) => ({
          item: item,
          trigger: item.querySelector('[data-faq-trigger]'),
          content: item.querySelector('[data-faq-content]')
        }))
        .filter((entry) => entry.trigger && entry.content);

      this.toggleAllBtn = this.querySelector('[data-toggle-all-btn]');

      this.initItems();
      this.initToggleAll();
      this.initScrollButtons();
      this.updateToggleButtonText();
    }

    /* ---------------------------------------------------------------- items */

    initItems() {
      this.items.forEach((entry) => {
        const isOpen = entry.trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          entry.content.hidden = false;
          entry.content.style.maxHeight = 'none';
        } else {
          entry.content.hidden = true;
          entry.content.style.maxHeight = '0px';
        }

        entry.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleItem(entry);
        });
      });
    }

    toggleItem(entry) {
      const isOpen = entry.trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.closeItem(entry);
      } else {
        if (!this.allowMultiple) this.closeAllItems(entry);
        this.openItem(entry);
      }

      this.updateToggleButtonText();
    }

    openItem(entry) {
      const { trigger, content } = entry;

      trigger.setAttribute('aria-expanded', 'true');
      content.hidden = false;

      if (prefersReducedMotion()) {
        content.style.maxHeight = 'none';
        return;
      }

      content.style.maxHeight = content.scrollHeight + 'px';

      window.clearTimeout(entry.timer);
      entry.timer = window.setTimeout(() => {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          // Release the fixed height so the panel can reflow with its content.
          content.style.maxHeight = 'none';
        }
      }, this.animationDuration);
    }

    closeItem(entry) {
      const { trigger, content } = entry;

      trigger.setAttribute('aria-expanded', 'false');

      if (prefersReducedMotion()) {
        content.style.maxHeight = '0px';
        content.hidden = true;
        return;
      }

      // Re-anchor to a concrete height before collapsing so the transition runs.
      content.style.maxHeight = content.scrollHeight + 'px';
      // Force a reflow so the browser registers the starting height.
      void content.offsetHeight;
      content.style.maxHeight = '0px';

      window.clearTimeout(entry.timer);
      entry.timer = window.setTimeout(() => {
        if (trigger.getAttribute('aria-expanded') === 'false') {
          content.hidden = true;
        }
      }, this.animationDuration);
    }

    closeAllItems(except) {
      this.items.forEach((entry) => {
        if (entry === except) return;
        if (entry.trigger.getAttribute('aria-expanded') === 'true') {
          this.closeItem(entry);
        }
      });
    }

    openAllItems() {
      this.items.forEach((entry) => {
        if (entry.trigger.getAttribute('aria-expanded') !== 'true') {
          this.openItem(entry);
        }
      });
    }

    /* ----------------------------------------------------------- toggle all */

    initToggleAll() {
      if (!this.toggleAllBtn) return;

      this.toggleAllBtn.addEventListener('click', () => {
        if (this.allOpen()) {
          this.closeAllItems();
        } else {
          this.openAllItems();
        }

        this.updateToggleButtonText();
      });
    }

    allOpen() {
      return (
        this.items.length > 0 &&
        this.items.every((entry) => entry.trigger.getAttribute('aria-expanded') === 'true')
      );
    }

    allClosed() {
      return this.items.every((entry) => entry.trigger.getAttribute('aria-expanded') !== 'true');
    }

    updateToggleButtonText() {
      if (!this.toggleAllBtn) return;

      const expandText = this.toggleAllBtn.getAttribute('data-expand-text') || 'Expand All';
      const collapseText = this.toggleAllBtn.getAttribute('data-collapse-text') || 'Collapse All';

      this.toggleAllBtn.textContent = this.allOpen() ? collapseText : expandText;
      this.toggleAllBtn.setAttribute('aria-expanded', this.allOpen() ? 'true' : 'false');
    }

    /* -------------------------------------------------------- scroll button */

    initScrollButtons() {
      this.querySelectorAll('[data-scroll-target]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const targetClass = button.getAttribute('data-scroll-target');
          if (!targetClass) return;

          let target = null;
          try {
            target = document.querySelector('.' + CSS.escape(targetClass));
          } catch (error) {
            target = null;
          }
          if (!target) return;

          target.scrollIntoView({
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      });
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
})();
